import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers, ReactNodeGenerator} from '../../../../../lib/helpers';
import {EditContentStore} from '../../../x7/content-parts/EditContentStore';
import {MQMatchingQuestion} from '../models';
import {MQDataPairComponent} from './parts/MQDataPairComponent';
import {MQOptionsComponent} from './parts/MQOptionsComponent';
import {MQEditStore} from './stores/MQEditStore';

function* renderer(store: MQEditStore): ReactNodeGenerator {
  const swappable = store.options.leftSide.value === 'text';
  yield (
    <MQOptionsComponent key="matching-question-options"
                        store={store.options}>
      <button type="button" className="btn btn-primary"
              disabled={!swappable}
              onClick={store.swapLeftAndRight}>
        Swap
      </button>
      <button type="button" className="btn btn-primary"
              onClick={store.addPair}>
        Add
      </button>
    </MQOptionsComponent>);

  const options = store.options.options;
  for (let index = 0; index < store.dataPairs.length; index++) {
    let dataPair = store.dataPairs[index];
    yield (
      <MQDataPairComponent key={'data-pair-' + index}
                           options={options}
                           store={dataPair}>
        <button type="button" className="btn btn-primary" onClick={() => store.removePair(index)}>
          Remove
        </button>
      </MQDataPairComponent>);
  }
}

@observer
export class X9MatchingQuestionEdit extends React.Component<{ store: EditContentStore }> {
  readonly store: MQEditStore;
  disposers: Disposers;

  constructor(props: Readonly<{ store: EditContentStore; }>) {
    super(props);
    this.disposers = new Disposers();
    this.store = new MQEditStore();
    this.disposers.add(this.store);

    const value = props.store.content.Contents;
    const mq = JSON.parse(value) as MQMatchingQuestion;
    this.store.sync(mq);
    this.setup();
  }

  setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        (valid) => this.props.store.setValid(valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Contents,
        (contents) => this.props.store.setContents(contents),
        {fireImmediately: true})
    );
  }

  render() {
    const store = this.store;

    return (Array.from(renderer(store)));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
